import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    EventConfirmByEmailQuery,
    EventConfirmByEmailQueryVariables,
} from './ConfirmByEmail.queries.generated'

export const GET_EVENT_CONFIRM_BY_EMAIL: TypedDocumentNode<
    EventConfirmByEmailQuery,
    EventConfirmByEmailQueryVariables
> = gql`
    query EventConfirmByEmail($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Event {
                title
                url
                attendees {
                    total
                    totalAccept
                }
                maxAttendees
                enableMaybeAttendEvent
                attendEventOnline
                isFormEnabled
                form {
                    __typename @include(if: false)
                    title
                    description
                    formFields {
                        __typename @include(if: false)
                        guid
                        title
                        description
                        fieldType
                        isMandatory
                        fieldOptions
                    }
                }
            }
        }
    }
`
